import React from "react";
import { useObserver } from "mobx-react";
import { Grid, Tooltip, Typography } from "@material-ui/core";
import locale from "@bonliva-crm/locale";
import BasicSelect from "@components/Select";
import { useConsultantEditorContext } from "../ConsultantEditorContext";
import { ConsultantEditorStore } from "../ConsultantEditorStore";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";

export function GDPRInfo() {
  const editorStore: ConsultantEditorStore = useConsultantEditorContext();

  return useObserver(() => {
    const gdprErrors = editorStore.form.errors.GDPRConsentRecords as unknown as
      | Record<string, string>
      | undefined;

    return (
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Typography variant={"body2"}>
            {locale.GDPRHelpText1}{" "}
            <Tooltip
              title={
                <span style={{ whiteSpace: "pre-line" }}>{locale.GDPRHelpText2}</span>
              }
            >
              <InfoOutlinedIcon fontSize={"small"} style={{ verticalAlign: "bottom" }} />
            </Tooltip>
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <BasicSelect
            name="GDPRConsentRecords.marketingConsentOption"
            resetValue={null}
            fullWidth
            label={locale.ApprovedMarketing}
            options={Object.keys(locale.consultantGDPROption).toLabelValue(
              (c) => locale.consultantGDPROption[c]
            )}
            onChange={editorStore.updateMarketingConsentOption}
            value={editorStore.marketingConsentOption}
            required
            error={!editorStore.marketingConsentOption}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <BasicSelect
            name="GDPRConsentRecords.marketingConsentChannel"
            resetValue={null}
            fullWidth
            disabled={!editorStore.isMarketingConsentEnabled}
            label={locale.InformationCameVia}
            options={Object.keys(locale.consultantGDPRChannelShort).toLabelValue(
              (c) => locale.consultantGDPRChannelShort[c]
            )}
            onChange={editorStore.updateMarketingConsentChannel}
            value={editorStore.marketingConsentChannel}
            required={editorStore.isMarketingConsentEnabled}
            error={Boolean(gdprErrors?.marketingConsentChannel)}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <BasicSelect
            name="GDPRConsentRecords.mailingEmailConsentOption"
            resetValue={null}
            fullWidth
            label={locale.ApprovedMailingVia("Email")}
            options={Object.keys(locale.consultantGDPROption).toLabelValue(
              (c) => locale.consultantGDPROption[c]
            )}
            onChange={editorStore.updateMailingEmailConsentOption}
            value={editorStore.mailingEmailConsentOption}
            required
            error={!editorStore.mailingEmailConsentOption}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <BasicSelect
            name="GDPRConsentRecords.mailingEmailConsentChannel"
            resetValue={null}
            fullWidth
            disabled={!editorStore.isMailingEmailConsentEnabled}
            label={locale.InformationCameVia}
            options={Object.keys(locale.consultantGDPRChannelShort).toLabelValue(
              (c) => locale.consultantGDPRChannelShort[c]
            )}
            onChange={editorStore.updateMailingEmailConsentChannel}
            value={editorStore.mailingEmailConsentChannel}
            required={editorStore.isMailingEmailConsentEnabled}
            error={Boolean(gdprErrors?.mailingEmailConsentChannel)}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <BasicSelect
            name="GDPRConsentRecords.mailingSmsConsentOption"
            resetValue={null}
            fullWidth
            label={locale.ApprovedMailingVia("SMS")}
            options={Object.keys(locale.consultantGDPROption).toLabelValue(
              (c) => locale.consultantGDPROption[c]
            )}
            onChange={editorStore.updateMailingSmsConsentOption}
            value={editorStore.mailingSmsConsentOption}
            required
            error={!editorStore.mailingSmsConsentOption}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <BasicSelect
            name="GDPRConsentRecords.mailingSmsConsentChannel"
            resetValue={null}
            fullWidth
            disabled={!editorStore.isMailingSmsConsentEnabled}
            label={locale.InformationCameVia}
            options={Object.keys(locale.consultantGDPRChannelShort).toLabelValue(
              (c) => locale.consultantGDPRChannelShort[c]
            )}
            onChange={editorStore.updateMailingSmsConsentChannel}
            value={editorStore.mailingSmsConsentChannel}
            required={editorStore.isMailingSmsConsentEnabled}
            error={Boolean(gdprErrors?.mailingSmsConsentChannel)}
          />
        </Grid>
      </Grid>
    );
  });
}
